import styled from "styled-components";

export const noCodeFoundColor = "#00000080";
export const codeDetectedLineColor = "rgba(255, 201, 14, 0.6)";
export const codeFoundShadeColor = "#3FC77266";
export const codeFoundLineColor = "#0BC154CC";
export const noCodeFoundLineThickness = "4px";
export const codeFoundLineThickness = "6px";

export const LiveLinearBarcodeScannerContainer = styled.div`
    width: 100%;
    height: 100%;

    --container-shade-background-color: ${noCodeFoundColor};
    --container-line-background-color: ${noCodeFoundColor};
    --container-line-thickness: ${noCodeFoundLineThickness};
    --line-container-flex-grow: 1;

    overflow: hidden;
    display: flex;
    position: relative;

    > div.llbs-no-camera {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        color: ${p => p.theme.fgColorDark};
        display: flex;
        align-items: center;
        justify-content: center;
    }

    > div.llbs-video-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    video.llbs-video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    > div.llbs-bounding-container {
        position: absolute;
        top: 0;
        left: 0;

        z-index: 1;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        > div.llbs-bounding-shade {
            background-color: var(--container-shade-background-color);
            width: 100%;
            height: 100%;

            flex-shrink: var(--line-container-flex-grow);
        }

        > div.llbs-bounding-line-container {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-grow: var(--line-container-flex-grow);
            width: 100%;
            height: 100%;

            > div.llbs-bounding-line {
                background-color: var(--container-line-background-color);
                height: var(--container-line-thickness);
                border-radius: 2px;
                width: 80%;
            }
        }
    }
`;
